import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { NumberInput, TextInput } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import AircraftTypeInput from "../../../../Components/ReferenceFields/AircraftType/AircraftTypeInput";
import CustomerInput from "../../../../Components/ReferenceFields/Customer/CustomerInput";

const AircraftCreateForm = props => {
  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Information
                </Typography>
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <CustomerInput label="Customer" fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <AircraftTypeInput label="A/C Type" fullWidth />
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="acRegistration" label="A/C Registration" fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="aircraftMsn" label="A/C MSN" fullWidth />
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <CustomDatetime source="manufacturatedDate" label="Manufacturated Date" fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <CustomDatetime
                    options={{ format: "DD/MMM/YYYY" }}
                    source="joinToFleetDate"
                    label="Join to Fleet Date"
                    fullWidth
                  />
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={0.5} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="aircraftAge" label="A/C Age" fullWidth />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default AircraftCreateForm;
